import type { BitkitIconComponent } from '@bitrise/bitkit-v2';
import {
  BitkitButton,
  IconBitbucketColor,
  IconGithub,
  IconGitlabColor,
  IconGoogleColor,
  IconKey,
  rem,
} from '@bitrise/bitkit-v2';
import type { HTMLChakraProps, RecipeProps } from '@chakra-ui/react/styled-system';
import { forwardRef } from 'react';

import { SocialLoginProviders } from '@/constants';

export type SocialButtonProps = HTMLChakraProps<'button'> &
  RecipeProps<'button'> & {
    provider: SocialLoginProviders;
    textBefore?: string;
    textAfter?: string;
  };

const iconMap: Record<string, BitkitIconComponent> = {
  GitHub: IconGithub,
  Bitbucket: IconBitbucketColor,
  GitLab: IconGitlabColor,
  Google: IconGoogleColor,
  SSO: IconKey,
};

const SocialLoginButton = forwardRef<HTMLElement, SocialButtonProps>(
  ({ provider, textBefore, textAfter = '', ...rest }, ref) => {
    const icon = iconMap[provider] ?? IconKey;
    const label = textBefore ? `${textBefore} ${provider} ${textAfter}`.trim() : provider;

    return (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      <BitkitButton icon={icon} ref={ref} variant="secondary" minWidth={rem(160)} {...(rest as any)}>
        {label}
      </BitkitButton>
    );
  },
);

SocialLoginButton.displayName = 'SocialLoginButton';

export default SocialLoginButton;
